import * as types from './actionTypes';

export const updateUser = (value) => ({ type: types.SET_USER, value});
export const updateToken = (value) => ({ type: types.SET_TOKEN, value});
export const setLoading = (value) => ({ type: types.SET_LOADING, value});